/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useState} from 'react';
import {Dimensions, Platform, ScrollView, View} from 'react-native';
import {connect} from 'react-redux';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {MenuItem} from '../../components/MenuItem';
import DeclarerSuiviMenu from './DeclarerSuiviMenu';
import { StackParams } from '../../../data/types/navigation';
import globalStyle from '../../styles/globalStyle';
import { buttonsStyles } from '../../components/Button/boutonStyle';
import PrimaryButton from '../../components/Button/PrimaryButton';
import { HeaderScreen } from '../../components/Header/HeaderScreen';
import { formsStyles } from '../../components/Inputs/formStyles';
import { SuivreSinistre } from './SuivreSinistre';
import { sinistresList } from '../../../data/constants/Sinistres/sinistre';

type NavigationProps = StackNavigationProp<StackParams, 'MesSinistres'>;

export function MesSinistresScreen(props: any) {
  const {navigate} = useNavigation<NavigationProps>();
  const {getNumeroPoliceUser, user} = props;
  const [active, setActive] = useState('Declarer');

  user &&
    user.numeroPolice &&
    user.numeroPolice.length > 0 &&
    getNumeroPoliceUser('', () => {});

  const callback = (data: string) => {
    setActive(data);
  };

  const DeclarerComponent = () => {
    return (
      <View style={{justifyContent: 'flex-start'}}>
        <View
          style={
            Platform.OS === 'web'
              ? [globalStyle.containerFluid, {padding: 8}]
              : [globalStyle.mobileContainerFluid]
          }>
          <MenuItem data={sinistresList} isHome={false} />
        </View>
        <View style={buttonsStyles.displayCenter}>
          <PrimaryButton
            onPress={() => {
              navigate('MesContrats');
            }}
            styleBtnTxt={buttonsStyles.btnValider}
            styleBtnOuter={buttonsStyles.btnValiderOuterSinistre}
            title="Accéder à mes contrats"
            type="valider"
          />
        </View>
      </View>
    );
  };

  const windowHeight = Dimensions.get('window').height;
  return (
    <View style={{flex: 1}}>
      <HeaderScreen
        title="Compte > Mes sinistres"
        type="GoToMonEspace"
        noBreadcrumb={false}
      />
      <ScrollView>
        <View style={[formsStyles.webformContain]}>
          <View
            style={[
              formsStyles.formContain,
              {minHeight: windowHeight - 80, backgroundColor: '#fff'},
            ]}>
            <DeclarerSuiviMenu active={active} callBack={callback} />
            {active === 'Declarer' ? <DeclarerComponent /> : <SuivreSinistre />}
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
export const MesSinistres: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MesSinistresScreen);
